import { Consultant } from '../models/Consultant';
import { EligibilityValidationModel } from '../models/EligibilityValidationModel';
import { GrantProgramTierConfiguration } from '../models/GrantProgramTierConfiguration'
import { MinimumMarketingSpendEligibilityModel } from '../models/MinimumMarketingSpendEligibilityModel'
import { ValidateMinimumMarketingSpendEligibilityModel } from '../models/ValidateMinimumMarketingSpendEligibilityModel'
import { FetchBase } from '../shared/FetchBase'

export interface OptionItem {
    value: number;
    label: string;
}

export class ApplicationFetch extends FetchBase {
  constructor() {
    super('', '/api/application')
  }

  // eslint-disable-next-line class-methods-use-this
  fetchPriorityTradeAreas(): Promise<OptionItem[]> {
    // return this.ajaxRequest('GET', 'priority-trade-areas')

    // Temoporary quick fix - hard coding here to avoid a server call for performance
    const priorityTradeAreas = [
      { value: 1, label: 'Agrifood' },
      { value: 2, label: 'Critical and enabling technologies' },
      { value: 3, label: 'Defence capability' },
      { value: 4, label: 'Education and skills' },
      { value: 5, label: 'Green economy' },
      { value: 6, label: 'None of the above' },
    ]

    return new Promise((resolve) => {
      resolve(priorityTradeAreas)
    })
  }

  // eslint-disable-next-line class-methods-use-this
  getBankNameExcludedAsciiString(): Promise<string[]> {
    // return this.ajaxRequest('GET', 'getBankNameExcludedAscii')

    // Temoporary quick fix - hard coding here to avoid a server call for performance
    const excludedAscii = ['"', '<', '=', '>', '`', '{', '|', '}', '~']

    return new Promise((resolve) => {
      resolve(excludedAscii)
    })
  }

  validateTierYearlyLimitEligibility(abn: string, financialYearName: string, isRepresentativeBody: boolean, appTier?: number) {
    return this.ajaxRequest('GET', `validateTierYearlyLimitEligibility?abn=${abn}&financialYearName=${financialYearName}&isRepresentativeBody=${isRepresentativeBody}&appTier=${appTier}`)
  }

  getGrantProgramTierConfig(): Promise<GrantProgramTierConfiguration[]> {
    return this.ajaxRequest('GET', 'getGrantProgramTierConfig')
  }

  async validateMinimumMarketingSpendEligibility(model:ValidateMinimumMarketingSpendEligibilityModel): Promise<MinimumMarketingSpendEligibilityModel> {
    return this.ajaxRequest('POST', 'validateMinimumMarketingSpendEligibility', model)
  }

  async validateYearsInBusinessEligibility(dateOperationsCommenced: string, grantProgramRound: string, isRepresentativeBody: boolean, appTier: string): Promise<EligibilityValidationModel> {
    return this.ajaxRequest('GET', `validateYearsInBusinessEligibility?dateOperationsCommenced=${dateOperationsCommenced}&grantProgramRound=${grantProgramRound}&isRepresentativeBody=${isRepresentativeBody}&appTier=${appTier}`)
  }

  async getEmdgApplicationNumberById(id: string): Promise<any> {
    return this.ajaxRequest('GET', `getEmdgApplicationNumberById?id=${id}`)
  }

  async assignAgentToApplication(data: { applicationID: string, claimRandomIdentifier: string, agentCode: string }): Promise<any> {
    return this.ajaxRequest('POST', 'assignAgentToApplication', data)
  }

  async getLatestAgentsDetails(owningAccountId: string): Promise<Consultant[]> {
    return this.ajaxRequest('GET', `getLatestAgentsDetails?owningAccountId=${owningAccountId}`)
  }
}
